import { useProfile } from "Components/Hooks/UserHooks";
import { RecordKindConfig } from "./types";

/** The current user's role permissions for one kind of record. */
export const useRecordPermissions = (config: RecordKindConfig) => {
  const { userProfile } = useProfile();
  const { resource, controller } = config.permissions;
  const actions = userProfile?.permissions?.[`api::${resource}`]?.controllers?.[controller];
  const allowed = (action: string) => !!actions?.[action]?.enabled;

  const canAdd = allowed(config.permissions.add);
  const canEdit = allowed(config.permissions.edit);
  const canRemove = allowed(config.permissions.remove);

  return { canAdd, canEdit, canRemove, canManage: canAdd || canEdit || canRemove };
};
